var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-picker',{ref:"date",attrs:{"value":_vm.value,"lang":_vm.lang,"placeholder":_vm.placeholder,"width":_vm.width,"popupStyle":_vm.popupStyle || {left: 0},"format":_vm.format},on:{"input":_vm.change,"panel-change":_vm.handlePanelChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b7c11c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fields/Date.vue
// module id = null
// module chunks = 